module.exports = __webpack_public_path__ + "cca21143c5a15f71eeddb6b07a91f571.ttf";